import { createSlice } from "@reduxjs/toolkit";
import { requestAlias } from "../requests/thunks/requestAlias";
import { requestPartPaymentWidget } from "../requests/thunks/requestPartPaymentWidget";

const getCurrency = channelId => {
  switch (channelId) {
    case "1":
      return "SEK";
    case "4":
      return "NOK";
    case "7":
      return "EUR";
    case "8":
      return "EUR";
    default:
      console.error("Unexpected channelId in getCurrency");
      return "";
  }
};

const getBaseRoute = channelId => {
  switch (channelId) {
    case "1":
      return "/cguide";
    case "4":
      return "/cguide";
    case "7":
      return "/fi/sv/cguide";
    case "8":
      return "/fi/fi/cguide";
    default:
      break;
  }
  console.error("Unexpected channelId in getBaseRoute");
  return channelId;
};

const initialState = {
  channelId: "",
  currency: "",
  baseRoute: "",
  assetBaseUrl: "",
  articleImageBaseUrl: "",
  alias: [],
  partPaymentWidget: null,
};

const initSlice = createSlice({
  name: "init",
  initialState,
  reducers: {
    setPropertiesForChannel(state, action) {
      const channelId = action.payload;

      const currency = getCurrency(channelId);
      const baseRoute = getBaseRoute(channelId);

      state.channelId = channelId;
      state.currency = currency;
      state.baseRoute = baseRoute;
    },
    setImageBaseUrls(state, action) {
      const { assetBaseUrl, articleImageBaseUrl } = action.payload;

      state.assetBaseUrl = assetBaseUrl;
      state.articleImageBaseUrl = articleImageBaseUrl;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(requestAlias.fulfilled, (state, action) => {
        const { alias } = action.payload;
        state.alias = alias;
      })
      .addCase(requestPartPaymentWidget.fulfilled, (state, action) => {
        const { token, url, minPayment, maxPayment } = action.payload;
        state.partPaymentWidget = {
          token,
          scriptUrl: `${url}/walley-checkout-loader.js`,
          minPayment,
          maxPayment,
        };
      });
  },
});

export const { setPropertiesForChannel, setImageBaseUrls } = initSlice.actions;

export default initSlice.reducer;
